import React from 'react';

import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import BaseModal from '@components/molecules/modals/BaseModal';
import TextField from '@mui/material/TextField';
import ButtonCallAction from '@/components/BI/buttonCallAction';
import { ReactComponent as SaveIcon } from '@assets/icons/SaveIcon.svg';
import { Typography } from '@mui/material';

const CreateSimulatorHistoryModal = ({ handleClose, open, title, setTitle, handleCreateSimulatorHistory }) => {
    return (
        <BaseModal handleClose={handleClose} open={open} title="Salvar simulação">
            <Typography variant="h6" sx={{ fontSize: '16px', textAlign: 'center' }}>
                Dê um nome para essa simulação
            </Typography>
            <Grid container spacing={2} mt={1} mb={3}>
                <Grid item xs={12}>
                    <TextField size="small" fullWidth label="Nome da simulação" value={title} onChange={(e) => setTitle(e.target.value)} />
                </Grid>
            </Grid>
            <Grid container spacing={2} display="flex" justifyContent="center">
                <Grid item xs={12} display="flex" justifyContent="center">
                    <ButtonCallAction
                        width="190px"
                        variant="contained"
                        placeholder="Nome da simulação"
                        size="small"
                        onClick={() => {
                            handleCreateSimulatorHistory();
                            handleClose();
                        }}
                        Icon={SaveIcon}
                        iconSize={24}
                        sx={{ textTransform: 'none', width: '190px', height: '44px', fontWeight: 600 }}
                    >
                        Salvar
                    </ButtonCallAction>
                </Grid>
            </Grid>
        </BaseModal>
    );
};

export default CreateSimulatorHistoryModal;
CreateSimulatorHistoryModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    setTitle: PropTypes.func.isRequired,
    handleCreateSimulatorHistory: PropTypes.func.isRequired
};
